import EventEmitter from 'eventemitter3';
import { POPIN_EVENT } from './popinEvent';

export default class Popin extends EventEmitter {
  constructor(name, container) {
    super();

    this._opened = false;

    this._name = name;
    this._container = container;

    this._getDom();
    this._bind();
  }

  _bind() {
    if (this._dom.close) {
      this._dom.close.addEventListener('click', this.close.bind(this));
    }
  }

  _getDom() {
    this._dom = {};
    this._dom.close = this._container.querySelector('.js-popin-close');
  }

  getName() {
    return this._name;
  }

  isOpened() {
    return this._opened;
  }

  open() {
    this._container.classList.add('show');
    this._opened = true;
    this.emit(POPIN_EVENT.OPENED, this._name);
  }

  close(emit) {
    this._container.classList.remove('show');
    this._opened = false;
    if (emit) {
      this.emit(POPIN_EVENT.CLOSED, this._name);
    }
  }
}
